<template>
  <div class="giveaways">
      
      <!-- Active Competitions -->

      <section class="container">
            <div class="row" v-if="this.listings.length > 0">
              <h1 class="text-center mt-3">Live Draws</h1>
              <CompetitionListing v-for="listing in listings" v-bind:listing="listing" v-bind:key="listing.id" v-bind:account="account"/>
            </div>
            <div class="row" v-else>
              <h1 class="text-center mt-3">No active live draws.</h1>
            </div>
      </section>

  </div>

  <Footer />

</template>

<script>
import Api from '../scripts/api'

import Footer from '../components/global/Footer'
import CompetitionListing from '../components/home/CompetitionListing'
export default {
    components: {
        CompetitionListing,
        Footer
    },
    props: {
      account: Object
    },
    data() {
      return {
        listings: []
      }
    },
    async created() {
      var result = await Api.competition.listLive();
      if(result.status === 200) {
        this.listings = await result.json();
      }
      else {
        this.$toast.error('Could not retrieve listings.')
      }
    }
}
</script>
